import { ModalV2, Text, Flex, Button } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";

export const RemoveRoleModal = ({
  role,
  fullName,
  onHide,
  handleRemove,
  isSubmitting,
  isOpen,
}: {
  isOpen: boolean;
  role: string;
  fullName: string;
  onHide: () => void;
  handleRemove: () => Promise<void>;
  isSubmitting: boolean;
}) => {
  return (
    <ModalV2
      title="Remove Canopy role"
      description={role}
      isCentered
      show={isOpen}
      onHide={onHide}
      size="small"
    >
      <ModalV2.Body>
        <Text
          variant="regular-md"
          marginBottom="md"
        >{`Are you sure you want to remove the ${role} role from ${fullName}?`}</Text>
        <Text
          variant="regular-md"
          marginBottom="md"
        >{`Any active work assigned to ${fullName} will be need to be unassigned.`}</Text>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-end"
          gap={SPACING.MEDIUM}
        >
          <Button variant="neutral" onClick={onHide}>
            Cancel
          </Button>
          <Button onClick={handleRemove} disabled={isSubmitting} variant="danger">
            Remove Canopy role
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
